import { z } from 'zod';

export const toggleDividendsReinvestPostRequestSchema = z.object({ investment_product: z.string() });
